import React from 'react';
import { Box } from '@mui/material';
import Alert from './Alert';
import { useToastContext } from '../../../context/ToastContextProvider';

const ToastContainer: React.FC = () => {
    const { toasts, closeToast } = useToastContext();
    if (toasts.length === 0) return null;

    return (
        <Box
            sx={{
                position: 'fixed',
                top: '80px',
                right: '20px',
                // upstream 5f73b07: yeni dogrulama toast'lari MUI Dialog
                // (z-index 1300 + portal yigini) USTUNDE gorunmeli.
                zIndex: 14000,
                display: 'flex',
                flexDirection: 'column',
                gap: '6px',
                alignItems: 'flex-end',
            }}
        >
            {toasts.slice().reverse().map((toast) => (
                <Alert
                    key={toast.id}
                    type={toast.type}
                    title={toast.title}
                    message={toast.message}
                    onClose={() => closeToast(toast.id)}
                    duration={toast.duration}
                />
            ))}
        </Box>
    );
};

export default ToastContainer;